import { IStorageLocal } from "namirasoft-core";
import { NamirasoftMap } from "namirasoft-site-map";
import { ProductUUID } from "namirasoft-api-product";
import { RequestInputRow, RequestRow } from "namirasoft-quota";
import { IEntityInfo, NSARouterMakerResult } from "namirasoft-account-react";
import { BaseColumnFormatter, DateTimeFormatter, EnumFormatter, ForeColorFormatter, IDFormatter, IntegerFormatter, StringFormatter, StringFormatterSizeType } from "namirasoft-site-react";

import { QuotaRouterProps } from "./QuotaRouterProps";
import { QuotaRoutes } from "./QuotaRoutes";

export class QuotaEntities
{
    static request(props: NSARouterMakerResult & QuotaRouterProps): IEntityInfo<RequestRow, RequestInputRow>
    {
        let namirasoft = new NamirasoftMap(props.account.token_manager, console.error);

        return {
            product_id: ProductUUID.NAMIRASOFT_QUOTA,
            name: "request",
            tables: [{ table: namirasoft.quota.tables.request, required: false }],
            client: {
                getColumns: () =>
                {
                    return [
                        BaseColumnFormatter.getColumn(namirasoft.quota.tables.request.columns.id, new IDFormatter(namirasoft, null)),
                        BaseColumnFormatter.getColumn(namirasoft.quota.tables.request.columns.user_id, new IDFormatter(namirasoft, new IStorageLocal())),
                        BaseColumnFormatter.getColumn(namirasoft.quota.tables.request.columns.product_id, new IDFormatter(namirasoft, new IStorageLocal())),
                        BaseColumnFormatter.getColumn(namirasoft.quota.tables.request.columns.action_id, new StringFormatter()),
                        BaseColumnFormatter.getColumn(namirasoft.quota.tables.request.columns.current_value, new IntegerFormatter()),
                        BaseColumnFormatter.getColumn(namirasoft.quota.tables.request.columns.current_unit, new StringFormatter(StringFormatterSizeType.TwoWords)),
                        BaseColumnFormatter.getColumn(namirasoft.quota.tables.request.columns.new_value, new IntegerFormatter()),
                        BaseColumnFormatter.getColumn(namirasoft.quota.tables.request.columns.new_unit, new StringFormatter(StringFormatterSizeType.TwoWords)),
                        BaseColumnFormatter.getColumn(namirasoft.quota.tables.request.columns.status, new ForeColorFormatter(new EnumFormatter(), {
                            Requested: "orange",
                            Approved: "green",
                            Rejected: "red"
                        })),
                        BaseColumnFormatter.getColumn(namirasoft.quota.tables.request.columns.created_at, new DateTimeFormatter()),
                        BaseColumnFormatter.getColumn(namirasoft.quota.tables.request.columns.updated_at, new DateTimeFormatter()),
                    ]
                },
                getListURL: () => QuotaRoutes.RequestList,
                getNewURL: () => QuotaRoutes.RequestNew,
                getCopyURL: (id: string) => QuotaRoutes.RequestCopy(id),
                getEditURL: (id: string) => QuotaRoutes.RequestEdit(id),
                getViewURL: (id: string) => QuotaRoutes.RequestView(id),
            },
            server: {
                value_list: props.servers.quota.value.List,
                list: props.servers.quota.request.List,
                get: props.servers.quota.request.Get,
                create: props.servers.quota.request.Create,
                update: props.servers.quota.request.Update,
                delete: props.servers.quota.request.Delete,
            }
        }
    }
}